// extracted by mini-css-extract-plugin
export default {"header_dark":"Contact_header_dark__88mF+","row":"Contact_row__pPLDW","col":"Contact_col__XcXCv","email_id":"Contact_email_id__1qihY"};